export const hourlyCalendar = {
  title: "Hourly calendar",
  navSubtitle: "Hourly booking for your hotel",
  hotel: "Hotel",
  rooms: "Rooms",
  roomsAbbr: "rooms",
  noDisp: "N/A",
  footer: {
    free: "{n} free",
    occupied: "{n} occupied",
    cleaning: "{n} being cleaned",
    timezone: "Time zone: {tz}",
  },
  today: "Today",
  prevDay: "Previous day",
  nextDay: "Next day",
  newStay: "New stay",
  settingsBtn: "Hourly booking settings",
  retry: "Try again",
  dragHint: "Drag across a room to create a stay",
  groupFree: "{free} of {total} free",
  zoom: { label: "Zoom", compact: "Compact", normal: "Normal", wide: "Wide" },
  duration: { min: "{n} min", h: "{n} h", hmin: "{h} h {m} min" },
  kpi: {
    free: "Free now",
    occupied: "Occupied",
    cleaning: "Being cleaned",
    arrivals: "Arriving within 1 h",
    overdueAlert: "1 room is past its check-out time | {n} rooms are past their check-out time",
  },
  state: {
    free: "Free",
    freeNext: "Free · next {time}",
    soon: "Arrives at {time}",
    occupied: "Occupied",
    occupiedLeft: "Occupied · {time} left",
    overdue: "Overdue {time}",
    due: "Awaiting check-in",
    cleaning: "Cleaning · {time}",
    closed: "Closed",
    maintenance: "Out of service",
  },
  status: {
    booked: "Booked",
    in_house: "In progress",
    checked_out: "Finished",
    cancelled: "Cancelled",
    no_show: "No-show",
  },
  block: {
    noName: "No name",
    blocked: "Blocked",
    night: "Night",
    closed: "Closed",
    maintenance: "Out of service",
    left: "{time} left",
  },
  legend: {
    booked: "Booked",
    inHouse: "In progress",
    overdue: "Overdue",
    cleaning: "Cleaning",
    night: "Overnight booking",
    closed: "Closed",
  },
  rangeMenu: {
    create: "Create stay",
    createSub: "In the selected time range",
    block: "Block this time",
    blockSub: "The room won't be sold in that range",
    closeDay: "Close the room all day",
    closeDaySub: "This room isn't sold that day",
  },
  blockMenu: {
    editReason: "Change the reason",
    editReasonSub: "It shows on the calendar",
    remove: "Remove the block",
    removeSub: "The room goes back on sale",
  },
  blockModal: {
    titleRange: "Block this time",
    titleDay: "Close the room",
    titleEdit: "Block reason",
    msgRange: "{room} won't be sold from {range}.",
    msgDay: "{room} won't be sold on {date}.",
    msgDayRest: "{room} will not be sold for the rest of the day (from {time}).",
    msgEdit: "{room}",
    reasonLabel: "Reason",
    reasonHint: "(shows on the calendar)",
    placeholder: "Maintenance, own use…",
    cancel: "Cancel",
    block: "Block",
    save: "Save",
    presetMaintenance: "Maintenance",
    presetOwner: "Owner use",
    presetRepair: "Refurbishment",
    presetDeepClean: "Deep cleaning",
    presetClosed: "Closed",
  },
  drawer: {
    close: "Close",
    closeBtn: "Close",
    newTitle: "New stay",
    newPill: "New",
    when: "When",
    room: "Room",
    start: "Check-in",
    end: "Check-out",
    nextDay: "next day",
    duration: "Duration",
    other: "Other",
    free: "Room free at that time",
    freeWithCleaning: "Free · {n} min are kept for cleaning after checkout",
    freeWillClose: "Free · afterwards it stays closed until {hour}",
    busy: "Occupied from {from} to {to}",
    busyClosed: "Closed from {from} to {to}",
    busyMaintenance: "Room out of service",
    guest: "Guest",
    guestName: "Name",
    phone: "Phone",
    optional: "Optional",
    guests: "People",
    charge: "Payment",
    price: "Price",
    method: "Payment method",
    methods: { cash: "Cash", card: "Card", transfer: "Transfer", other: "Other" },
    paid: "Paid",
    paidHint: "You already have the money for this stay.",
    notes: "Notes",
    notesPh: "Licence plate, requests, anything useful",
    guestTitle: "Guest registration",
    sendCheckin: "Send the check-in link",
    sendCheckinHint: "It goes out when you save, to the guest's phone.",
    sendCheckinNoPhone: "Add the guest's phone to be able to send the check-in.",
    doCheckin: "Do the check-in",
    edit: "Edit",
    client: "Guest",
    paidYes: "Paid",
    paidNo: "Not paid",
    markPaid: "Mark as paid",
    doCheckinHint: "Open it on the guest's phone or share the link: name, surname and document, with a scan if they want.",
    copyLink: "Copy link",
    copied: "Link copied",
    checkinDone: "Check-in done · {n} guest registered | Check-in done · {n} guests registered",
    checkinErrors: {
      no_reservation: "Turn on «Register stays as bookings» in the settings to be able to request the check-in.",
      no_phone: "Add the guest's phone to be able to send it.",
      send_failed: "It could not be sent. Try copying the link and sharing it yourself.",
      not_requested: "It could not be sent. Try copying the link and sharing it yourself.",
    },
    checkinSent: "Check-in sent",
    sendCheckinFailed: "The check-in could not be sent. Check the guest's phone.",
    save: "Save",
    saveAndIn: "Save and check in",
    saveChanges: "Save changes",
    checkIn: "Check in",
    checkOut: "Check out",
    extend30: "30 min",
    extend60: "1 h",
    extendOther: "Other",
    extendHow: "Extend",
    extendApply: "Extend",
    cancelBtn: "Cancel",
    checkOutNotYet: "You can check out once the stay has started",
    confirmEarlyOutTitle: "The stay has not started yet",
    confirmEarlyOut: "This stay starts later. Checking out now closes it and frees the room. If the guest never came, use «No-show» instead.",
    noShow: "No-show",
    cancelStay: "Cancel stay",
    keep: "Go back",
    confirmCancel: "It is cancelled and the room is free at that time. This cannot be undone.",
    confirmNoShow: "The slot is free to sell again. It is recorded that the guest did not come.",
    confirmNoShowInHouse: "They were checked in but never went up: the check-in is undone and the slot is free again.",
    confirmCancelInHouse: "They were checked in: the check-in is undone, the stay is cancelled and the room is free. This cannot be undone.",
    confirmNoShowTitle: "Did they not show up?",
    confirmCancelTitle: "Cancel this stay?",
    remaining: "{time} left",
    overdue: "{time} past check-out time",
    startsIn: "Starts in {time}",
    waiting: "Its time has started: awaiting check-in",
    closedInfo: "Closed stay: only payment and notes can be changed.",
    night: {
      title: "Overnight booking",
      dates: "From {from} to {to}",
      code: "Code",
      channel: "Channel",
      hint: "Overnight bookings are managed from the hotel calendar. They are shown here so no hourly stay overlaps them.",
      open: "Go to the hotel calendar",
    },
  },
  settings: {
    title: "Hourly booking",
    enable: "Rent by the hour",
    subtitle: "How this hotel sells by the hour",
    offTitle: "If you turn it off",
    offBody: "The hourly calendar stops being available and the hotel works as before. Nothing is deleted.",
    offBodyStays: "You have {n} upcoming hourly stays: they aren't deleted, but you won't see them until you turn it back on.",
    enabledOn: "On: the hourly calendar is in use",
    enabledOff: "Off",
    requirements: "Requirements",
    req: {
      rooms: "Rooms created ({n})",
      channels: "No sales channels connected",
      ical: "No synced iCal calendars",
      web: "Online booking turned off",
      nights: "{n} upcoming overnight bookings: they will show on the calendar and block their rooms",
    },
    reqWhy: "Channels, iCal and your website sell nights and know nothing about hours: with any of them on, the same room could be sold twice.",
    cleaning: "Cleaning between stays",
    cleaningHint: "Reserved automatically after every check-out.",
    pending: "Pending cleaning",
    pendingHint: "When a guest leaves, the room is flagged “to clean” in Housekeeping and in the app for this long. It does NOT block sales: if someone checks in sooner, you clean it then.",
    none: "none",
    minutes: "min",
    hours: "h",
    closeTitle: "Close until opening time",
    closeHint: "For when you don't clean right away: the room stays closed and nobody can sell it until you open.",
    closeAfterStay: "When a stay ends, leave the room closed",
    closeAfterStayHint: "It closes by itself until the next day's opening time. If you clean it earlier, press “It's clean” and it goes back on sale right away.",
    afterTitle: "After each stay",
    afterHint: "How long the room stops being sellable once a guest leaves.",
    untilOpening: "Until opening",
    reopenHour: "Sales opening time",
    reopenNote: "Dirty rooms go back on sale at {hour}.",
    markClean: "It's clean",
    markCleanHint: "Opens the room now, without waiting for opening time.",
    closeThisStay: "Leave the room closed when it ends",
    closeThisStayHint: "It can't be sold until {hour}. Change the time in Settings.",
    dayStart: "Start of the calendar day",
    dayRange: "from {from} to {from} the next day",
    dayStartHint: "Pick your quietest hour so the night shows in one piece.",
    quickHours: "Quick durations",
    quickHoursHint: "Shown as shortcuts when creating a stay (up to 6).",
    guestTitle: "Guest registration",
    asReservation: "Register stays as bookings",
    asReservationHint: "Each stay creates its booking: that's how the money shows up in your reports, and how you can request check-in and guest registration. Turn it off and hourly sales won't count towards your revenue.",
    checkinDefault: "Request the check-in by default",
    checkinDefaultHint: "The switch on the stay's form will come turned on.",
    guestHint: "These bookings do not get the messages meant for nights (welcome, arrival, check-out or review): the check-in link is sent when you ask for it.",
    save: "Save settings",
    saved: "Settings saved",
  },
  empty: {
    eyebrow: "Hourly booking",
    title: "Rent your rooms by the hour",
    body: "A calendar built for motels and short-stay hotels: see every room minute by minute, create stays by dragging, and cleaning between them is reserved for you.",
    point1: "Real-time status for every room",
    point2: "Drag to create, move or extend stays",
    point3: "Automatic cleaning between stays",
    cta: "Turn on hourly booking",
    ctaBlocked: "Meet the requirements to turn it on",
    noHotelsTitle: "You don't have a hotel yet",
    noHotels: "Hourly booking works with hotel-type properties that have rooms created.",
  },
  guide: {
    open: "How it works",
    title: "How the hourly calendar works",
    subtitle: "The essentials in a minute: create stays, check guests in and out, and close rooms you are not selling.",
    createTitle: "Create a stay",
    createBody: "Drag along the room's row, from the check-in time to the check-out time. You can also click «New stay» and type the times yourself.",
    moveTitle: "Move and extend",
    moveBody: "Drag the bar to change its time or its room. Pull the right edge to make the stay longer or shorter. If the slot is taken, the calendar will not let you drop it.",
    checkinTitle: "Check-in and check-out",
    checkinBody: "Open the stay and check the guest in when they arrive, and out when they leave. If they run over, the bar turns red with the extra minutes.",
    cleaningTitle: "Cleaning between stays",
    cleaningBody: "After every check-out the calendar books the cleaning time you set. Nobody can check in during that window.",
    blockTitle: "Block a time slot or close the room",
    blockBody: "Select a range and choose «Block this time slot», or «Close the room all day» if you are not selling it that day. Click the block to change its reason or remove it.",
    settingsTitle: "Settings",
    settingsBody: "The gear is where you set the cleaning time, the hour the calendar day starts at, and the quick durations you see when creating a stay.",
    colorsTitle: "What each colour means",
    colors: {
      booked: "Created, the guest has not checked in yet",
      inHouse: "The guest is in the room",
      overdue: "Past the check-out time",
      cleaning: "Time booked for cleaning",
      night: "Comes from the nightly calendar",
      closed: "Blocked or closed by hand",
    },
    otasTitle: "Nightly bookings and channels",
    otasBody: "Nightly bookings show up here so you know which rooms are taken, but you manage them in the hotel calendar. While you sell by the hour, this property does not connect to OTAs.",
    gotIt: "Got it",
  },
  toasts: {
    created: "Stay created",
    checkedIn: "Check-in recorded",
    checkedOut: "Check-out recorded · cleaning started",
    updated: "Changes saved",
    extended: "Stay extended",
    cancelled: "Stay cancelled",
    noShow: "Marked as no-show",
    moved: "Stay moved",
    resized: "Duration updated",
    activated: "Hourly booking turned on",
    blocked: "Time blocked",
    blockUpdated: "Reason updated",
    blockRemoved: "Block removed",
    loadError: "The hourly calendar couldn't be loaded",
    error: "Couldn't save. Please try again.",
  },
  errors: {
    room_busy: "The room is occupied from {from} to {to}",
    hourly_disabled: "Hourly booking isn't turned on for this hotel.",
    room_maintenance: "That room is out of service.",
    room_not_found: "That room doesn't belong to this hotel.",
    invalid_duration: "Duration must be between 30 minutes and 48 hours.",
    invalid_start: "The check-in time isn't valid.",
    stay_closed: "This stay is already closed and can't be moved.",
    invalid_status: "That action isn't available for the stay's current status.",
    requirements_not_met: "This hotel doesn't meet the requirements for hourly booking yet.",
    not_found: "We couldn't find that. Please reload the page.",
    generic: "Something went wrong. Please try again.",
  },
};
